import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getRutas = async() => {
    const respuesta = await PrivateInterceptor(`IT/Rutas/`, 'GET')
    return respuesta;
}


export const guardarRuta = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/Rutas/AgregarRuta", "POST",{datos});
    return respuesta;
};
  
  export const editarRuta = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/Rutas/EditarRuta", "POST",{datos});
    return respuesta;
};

export const eliminarRuta = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/Rutas/Eliminar2Ruta", "POST",{datos});
    return respuesta;
};